
export function ContactTeam() {
    return (
        <div>
            <iframe border="0" src="https://krishnachaitanyav.wordpress.com/contact-form/" 
            style={{"width":"99.7%","height":"80vh"," background-color":" #ffffff","border":"0px"}}></iframe>
        </div>
    )
}